import { render, staticRenderFns } from "./BindsProgressBar.vue?vue&type=template&id=4b63a173&"
import script from "./BindsProgressBar.vue?vue&type=script&lang=js&"
export * from "./BindsProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./BindsProgressBar.vue?vue&type=style&index=0&id=4b63a173&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports